import React from 'react';
import styles from './breadcrumb.module.css';
import { useNavigate } from 'react-router-dom'
const Breadcrumb = ({ pathItems }) => {
  const navigate = useNavigate()
  return (
    <nav aria-label="breadcrumb">
      <ol className={styles.breadcrumbList}>
        {pathItems.map((item, index) => {
          const isLast = index === pathItems.length - 1;
          return (
            <li key={index} className={styles.breadcrumbItem}>
              {isLast ? (
                <span>{item.name}</span>
              ) : (
                <span className='cursor-pointer' onClick={() => navigate(item.url)}>{item.name}</span>
              )}
              {!isLast && <span className={styles.separator}> &gt; </span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
